module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.2387/img/callout-wave.svg"